import { render, staticRenderFns } from "./gCustomer.vue?vue&type=template&id=33f78564&scoped=true"
import script from "./gCustomer.vue?vue&type=script&lang=js"
export * from "./gCustomer.vue?vue&type=script&lang=js"
import style0 from "./gCustomer.vue?vue&type=style&index=0&id=33f78564&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f78564",
  null
  
)

export default component.exports